module.exports = __webpack_public_path__ + "img/female4.ea8703f6.jpg";